import styled from 'styled-components'
import {
    getCalendarGridContainerStyles,
    getCalendarGridStyles,
    getWeekdayHeaderStyles
} from '../style'
import { getDayCellStyles } from '../style'
import { DayCellProps } from '../type'

const StyledCalendarGridContainer = styled.div`
    ${getCalendarGridContainerStyles}
`

const StyledCalendarGrid = styled.div`
    ${getCalendarGridStyles}
`

const StyledWeekdayHeader = styled.div`
    ${getWeekdayHeaderStyles}
`

const StyledDayCell = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['isToday', 'isSelected', 'isCurrentMonth', 'isDisabled'].includes(
            prop
        )
})<DayCellProps>`
    ${getDayCellStyles}
`

export { StyledCalendarGrid, StyledWeekdayHeader, StyledDayCell }
export default StyledCalendarGridContainer
